import React from "react";
import { Box, FormControl } from "@mui/material";
import YesNoToggle from "./YesNoToggle";

export default function OrderDetailsToggles({
  menu3pm,
  onMenu3pmChange,
  orderSent,
  onOrderSentChange,
  orderReceived,
  onOrderReceivedChange,
  editable,
}) {
  return (
    <FormControl fullWidth sx={{ mt: 3 }}>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: { xs: 1, sm: 0 } }}>
      
        <YesNoToggle
          label="Menu By 3PM"
          value={menu3pm}
          onChange={onMenu3pmChange}
          disabled={!editable}
        />
        <YesNoToggle
          label="Confirmed by Vendor"
          value={orderSent}
          onChange={onOrderSentChange}
          disabled={!editable}
        />
        <YesNoToggle
          label="Sent to Vendor"
          value={orderReceived}
          onChange={onOrderReceivedChange}
          disabled={!editable}
        />
      </Box>
    </FormControl>
  );
}
